export default __webpack_public_path__ + "static/media/import.b9253eb4.svg";